<template>
  <div class="course-status">
    <!-- 拼团活动 -->
    <template v-if="signUpRemainTime < 1000 && activityInfo.activityType == 6">
      <div class="group-buy-btns">
        <div class="button button-normal button-primary btn-group-buy btn-join-in-group" @click="signUp({way: 'ACTIVITY_GROUP_NEW'})">
          <span class="desc-text">{{ groupParam.groupSize || '' }} People in Group Buy</span><!--
          --><span class="price-text">{{ currency }}{{ (activityInfo.perShowPrice !== undefined? activityInfo.perShowPrice:activityInfo.showPrice) | priceUnitConvert(minorUnit) }}<span v-if="activityInfo.perShowPrice !== undefined" class="per-lesson-text">{{ $t('courses.perLesson' ) }}</span></span><span class="icon-container"><i class="iconfont icon-next" /></span>
        </div>
        <div class="button button-normal button-default btn-group-buy" @click="signUp({way: 'NORMAL'})">
          <span class="desc-text">Register Individually</span><span class="price-text">{{ currency }}{{ (detailData.perShowPrice !== undefined? detailData.perShowPrice:detailData.showPrice) | priceUnitConvert(minorUnit) }}<span v-if="detailData.perShowPrice !== undefined" class="per-lesson-text">{{ $t('courses.perLesson' ) }}</span></span><span class="icon-container"><i class="iconfont icon-next" /></span>
        </div>
        <div class="button button-normal button-default btn-group-buy" @click="signUp({way: 'NORMAL',type: 'addCart'})">
          <span class="desc-text">{{ orderConfig.shoppingCart.addToCart }}</span><span class="icon-container"><i class="iconfont icon-next" /></span>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 开售倒计时 -->
      <div v-if="signUpRemainTime>1000" class="remain-times">
        <div class="time-wrap">
          <p class="remain-time">
            {{ remainDays }}
          </p>
          <p class="remain-desc">
            DAY
          </p>
        </div>
        <span class="remain-dot">:</span>
        <div class="time-wrap">
          <p class="remain-time">
            {{ remainHours }}
          </p>
          <p class="remain-desc">
            HOUR
          </p>
        </div>
        <span class="remain-dot">:</span>
        <div class="time-wrap">
          <p class="remain-time">
            {{ remainMinutes }}
          </p>
          <p class="remain-desc">
            MIN
          </p>
        </div>
        <span class="remain-dot">:</span>
        <div class="time-wrap">
          <p class="remain-time">
            {{ remainSeconds }}
          </p>
          <p class="remain-desc">
            SEC
          </p>
        </div>
      </div>
      <div class="collect-icon" :class="isWish?'collected':'collect'" @click="operateWish()" />
      <el-button
        :disabled="btnDisabled"
        class="button status"
        @click="signUp({way: 'NORMAL', type:'addCart'})"
      >
        {{ orderConfig.shoppingCart.addToCart }}
      </el-button>
      <el-button
        v-if="btnStatus!=='full'||!showRemind"
        class="button button-normal status"
        :class="btnStatus==='enrolNow' ?'button-stress':signUpRemainTime>1000?'sale':''"
        :disabled="!(btnStatus.includes('enrol')) "
        @click="signUp({way: 'NORMAL'})"
      >
        {{ btnText }}
      </el-button>

      <el-button v-if="showRemind" class="button button-normal  line-up-btn" @click="followHandler(followStatus)">
        {{ lineUpStatus() }}
      </el-button>
    </template>
    <InvitePopup
      ref="InvitePopup"
      :content="shareTxt"
      :url="shareUrl"
      :activity-id="activityInfo.activityId"
      title="Invite friends to join group buy"
      success-msg="Copied successfully! Share the group buy link with your friends now~"
    />
    <ConfirmDialog :append-to-body="true" :show.sync="followDialog" :title="followDialogText.title" :content="followDialogText.content" :main-btn-text="followDialogText.mainBtn" :show-sub-btn="true" :sub-btn-text="followDialogText.subBtn" :show-close="false" @mainBtnClick="confirmHandler" @subBtnClick="handleCancel" />
  </div>
</template>
<script>
import moment from 'moment-timezone';
import bus from 'common/bus.js'

import coursesSa from 'mixins/courses/sa.js';
import follow from 'mixins/courses/detail/follow.js'
import ConfirmDialog from 'components/common/ConfirmDialog';

import InvitePopup from 'components/share/InvitePopup'

export default {
  components: { InvitePopup, ConfirmDialog },
  mixins: [coursesSa, follow],
  props: {
    followSkuId: {
      type: String,
      default: '',
    },
    detailData: {
      type: Object,
      default: () => ({}),
    },
    activityInfo: {
      type: Object,
      default: () => ({}),
    },
    btnStatus: {
      type: String,
      default: '',
    },
    signUpRemainTime: {
      default: 0,
      type: Number,
    },
    isWish: {
      default: true,
      type: Boolean,
    },

  },
  data() {
    return {
      orderConfig: this.$t('order'),
      origin: '',
      shareTxt: '',
    }
  },
  computed: {
    btnDisabled() {
      // 满
      return this.btnStatus === 'full'
    },
    showRemind() {
      return this.btnStatus === 'full' && this.showStatus
    },
    btnText() {
      return this.$t(`coursesDetail.btnStatus.${this.btnStatus}`);
    },
    shareUrl() {
      return `${this.origin}/activity/group/detail/${this.$route.params.id}`
    },
    currency() {
      return this.$store.state.currency.symbol
    },
    minorUnit() {
      return this.$store.state.currency.minorUnit;
    },
    activityType() {
      return this.activityInfo.activityType
    },
    groupParam() {
      const groupData = JSON.parse(this.activityInfo.activityParam) || {}
      return groupData.groupParam || {}
    },
    remainDays() {
      const day = Math.floor(moment.duration(this.signUpRemainTime).asDays());
      return (`${day}`).padStart(2, '0');
    },
    remainHours() {
      let hour = Math.floor(moment.duration(this.signUpRemainTime - this.remainDays * 24 * 3600 * 1000).asHours());
      hour = (`${hour}`).padStart(2, '0');
      return hour
    },
    remainMinutes() {
      let min = moment.duration(this.signUpRemainTime - this.remainDays * 24 * 3600 * 1000 - 3600 * this.remainHours * 1000).minutes();
      min = (`${min}`).padStart(2, '0');
      return min
    },
    remainSeconds() {
      let second = moment.duration(this.signUpRemainTime - this.remainDays * 24 * 3600 * 1000 - 3600 * this.remainHours * 1000 - 60 * this.remainMinutes * 1000).seconds();
      second = (`${second}`).padStart(2, '0');
      return second
    },
  },
  mounted() {
    this.origin = window.location.origin
    this.getFollowRes(this.followSkuId)
  },
  methods: {
    operateWish() {
      if (!this.$store.state.ucenter.isLogin) {
        bus.$emit('login', {
          triggerSource: 'courses-detail-wish',
        });
        return
      }
      bus.$emit('operateWish')
    },
    signUp(orderInfo) {
      this.$emit('signUp', orderInfo)
    },
    toOrderDetail() {
      const orderId = this.$route.params.id;
      if (!orderId) return
      this.$router.push(`/order/detial/${orderId}`)
    },
    toCoursesSchedule() {
      const clazzId = this.detailData.spec.clazzId || ''
      if (!clazzId) return
      this.$router.push(`/my-courses/detail/${clazzId}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.course-status {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .status {
    display: flex;
    align-items: center;
    position: relative;
    // width: 400px;
    flex-grow: 1;
    height: 56px;
    box-sizing: border-box;
    padding: 8px 25px;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    border-radius: 28px;

    &.is-disabled {
      opacity: 0.3;
      padding: 8px 30px;
      color: var(--txt-color-lv2) !important;
      background: #dee2e7;

      span {
        color: var(--txt-color-lv2) !important;
      }
    }

    &.sale {
      width: 308px;
    }
  }

  .collect-icon {
    width: 52px;
    min-width: 52px;
    height: 52px;
    cursor: pointer;
    margin-right: 16px;

    &.collect {
      background: url("~assets/images/courses/collect.png");
      background-size: cover;
    }

    &.collected {
      background: url("~assets/images/courses/collected.png");
      background-size: cover;
    }
  }

  .remain-times {
    position: relative;
    top: 4px;
    display: flex;
    margin-top: 21px;
    margin-right: 16px;

    .remain-time {
      display: block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      background: var(--txt-color-link);
      border-radius: 3px;
    }

    .time-wrap {
      width: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .remain-dot {
      position: relative;
      line-height: 28px;
      color: var(--txt-color-lv2);
      margin: -2px 3px;
    }

    .remain-desc {
      text-align: center;
      font-size: 16px;
      transform: scale(0.5);
      font-weight: 600;
      letter-spacing: -1px;
      color: var(--txt-color-lv1);
    }
  }

  .group-buy-btns {
    .per-lesson-text {
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
    }

    .btn-group-buy {
      width: 400px;
      display: flex;
      align-items: center;
      margin: 0 auto 24px;
      height: 56px;
      cursor: pointer;

      &.btn-join-in-group {
        background: center/100% url('~assets/images/group-buy-activity/activity-price-right-bg.png');
      }

      .desc-text {
        margin-left: 0;
        margin-right: auto;
        word-spacing: 0;
        letter-spacing: 0;
        font-size: 18px;
        line-height: 24px;
      }

      .price-text {
        margin-right: 0;
        font-size: 22px;
        line-height: 24px;
      }

      .icon-container {
        margin-right: 0;
        margin-left: 12px;

        .iconfont {
          font-size: 24px;
        }
      }
    }
  }

  >.line-up-btn {
    width: 100%;
    height: 56px;
    margin-left: 5px;
  }
}
</style>
